import Vuex from 'vuex';
import Vue from 'vue';
import { setBasketCount } from '../../scripts/backend/common-catalog';

Vue.use(Vuex);

const vuexStore = new Vuex.Store({
    state: {
        outletLock: false,
        orders: [],
        form: {
            type: 1,

            firstName: '',
            lastName: '',

            city: '',
            street: '',
            house: '',
            flat: '',
            index: '',

            comment: '',
            phone: '',
            email: '',

            deliveryType: '',
            paymentType: '',
            fiasId: '',
        },
        coupon: {
            class: '',
            error: '',
        },
        ...window.basketVueStore,
    },

    getters: {
        getCurrentTab: state => state.currentTab,
        getPaymentType: state => state.paymentTypes[state.form.paymentType].name,
        getDeliveryType: state => state.deliveryTypes[state.form.deliveryType].name,
        getDeliveryPrice: state => state.deliveryTypes[state.form.deliveryType].price,
        getTotalPrice: (state, getters) => {
            let price = state.total.totalPrice;
            const arPrice = getters.getDeliveryPrice || [];
            // eslint-disable-next-line no-restricted-syntax
            for (const item of arPrice) {
                price += item.price;
            }
            return price;
        },
    },

    mutations: {
        updateBasket(state, { basketItems, total, appliedCoupons, deliveryTypes }) {
            state.basketItems = basketItems;
            state.total = total;
            state.appliedCoupons = appliedCoupons;
            state.deliveryTypes = deliveryTypes;

            setBasketCount(total.itemCount);
        },
        setCurrentTab: (state, tab) => {
            state.currentTab = tab;
        },
        updateForm: (state, form) => {
            state.form = form;
        },
        setOrder: (state, order) => {
            state.orders.push(order);
        },
        setOutletLock: (state, status) => {
            state.outletLock = status;
        },
        updateDeliveryPrice: (state, { serviceId, price }) => {
            state.deliveryTypes[serviceId].price = price;
        },
        updateFiasId: (state, fiasId) => {
            state.form.fiasId = fiasId;
        },
        updateCouponError: (state, error) => {
            state.coupon.error = error;
            state.coupon.class = error ? 'parsley-error' : '';
        },
    },

    actions: {
        removeBasketItem(context, { itemId, outlet }) {
            return new Promise((resolve, reject) => {
                $.post(`/api/internal/basket/delete/${itemId}`, {
                    fiasId: context.state.form.fiasId,
                    outlet,
                })
                    .done(result => {
                        context.commit('updateBasket', result.data);
                        resolve();
                    })
                    .fail(() => reject());
            });
        },
        changeQntBasketItem(context, { itemId, count, outlet }) {
            return new Promise((resolve, reject) => {
                $.post(`/api/internal/basket/change/${itemId}/${count}`, {
                    fiasId: context.state.form.fiasId,
                    outlet,
                })
                    .done(result => {
                        context.commit('updateBasket', result.data);
                        resolve();
                    })
                    .fail(() => reject());
            });
        },
        addCoupon(context, coupon) {
            if (!coupon) {
                context.commit('updateCouponError', 'Купон не введен');
                return '';
            }

            if (coupon.match(/[#+]/)) {
                context.commit('updateCouponError', 'Купон не найден');
                return coupon;
            }

            return new Promise((resolve, reject) => {
                $.post(`/api/internal/basket/add-coupon/${coupon}`, { fiasId: context.state.form.fiasId })
                    .done(result => {
                        if (!result.error_message) {
                            coupon = '';
                            context.commit('updateBasket', result.data);
                        }
                        context.commit('updateCouponError', result.error_message);
                        resolve(coupon);
                    })
                    .fail(() => {
                        context.commit('updateCouponError', 'Купон не найден');
                        reject();
                    });
            });
        },
        removeCoupon(context, coupon) {
            return new Promise((resolve, reject) => {
                $.post(`/api/internal/basket/delete-coupon/${coupon}`)
                    .done(result => {
                        context.commit('updateBasket', result.data);
                        resolve();
                    })
                    .fail(() => reject());
            });
        },
        setCurrentTab(context, tab) {
            context.commit('setCurrentTab', tab);
        },
        updateForm(context, form) {
            context.commit('updateForm', form);
        },
        setOrder(context, order) {
            context.commit('setOrder', order);
        },
        updateCouponError(context, error) {
            context.commit('updateCouponError', error);
        },
    },
});

export default vuexStore;
